<template>
    <div
        v-on:click="clicked()"
        :class="{'md-button': true, 'md-button': true, 'md-raised': true, 'md-primary': true, 'md-theme-default': true, 'md-theme-default': true, 'create-account-btn': true, 'create-account-bottom-btn': isBottom}" dusk="registration-form-create-account-bottom-button">
        <div class="md-ripple">
            <div class="md-button-content">
                {{label}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isBottom: {
            type: Boolean,
            required: false,
            default: false,
        },
        templateString: {
            type: String,
        },
    },
    data() {
        return {
        };
    },
    computed: {
        label() {
            if (this.isBottom && this.template && this.template.register_bottom_button_label && this.template.register_bottom_button_label[this.$i18n.locale()]) {
                return this.template.register_bottom_button_label[this.$i18n.locale()];
            } else if (this.template && this.template.register_button_label && this.template.register_button_label[this.$i18n.locale()]) {
                return this.template.register_button_label[this.$i18n.locale()];
            } else {
                return this.$t('home.i-register');
            }
        },
        template() {
            return this.parseProp(this.templateString) || {};
        },
    },
    methods: {
        clicked() {
            this.$emit('click');
        },
        parseProp(prop) {
            if (!prop) {
                return;
            }

            return JSON.parse(prop);
        },
    },
};
</script>

<style lang="scss" scoped>
.md-button {
    min-height: 36px;
    height: auto;
    padding: 5px 0;
}
.md-button-content {
    white-space: normal;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/button.vue